var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"week-row",on:{"click":_vm.showWeekNumber}},[(_vm.showWeekNumberFlag)?_c('div',{staticClass:"week-number"},[_vm._v(_vm._s("Week")+" "+_vm._s(_vm.week[0].date.format('w')))]):_vm._e(),_vm._l((_vm.week),function(day,index){return _c('Day',{key:index,attrs:{"day":day}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }